import {Injectable} from '@angular/core';

@Injectable()
export class DateTransformer {

    static transformDate(date: Date): string {
        date = new Date(date);
        if (date.toString() === 'Invalid Date') return '';

        let hr: any = date.getHours();
        hr = hr < 10 ? '0' + hr : hr;
        let min: any = date.getMinutes();
        min = min < 10 ? '0' + min : min;

        let ampm = 'am';
        if( hr > 12 ) {
            hr -= 12;
            ampm = 'pm';
        }
        let day = date.getDate();
        let month = date.getMonth() + 1;
        let year = date.getFullYear();

        return `${year}-${month}-${day} ${hr}:${min} ${ampm}`;
    }

}



// WEBPACK FOOTER //
// /app/src/app/services/date-transformer.service.ts